import React, { useState } from 'react';
import { CameraPreview } from '@capacitor-community/camera-preview';
import toast from 'react-hot-toast';
import { FaTimesCircle, FaInfoCircle } from 'react-icons/fa';

const CameraPreviewComponent = ({ onPhotoCapture }) => {
  const [photo, setPhoto] = useState(null);
  const [cameraActive, setCameraActive] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const cameraOptions = {
    position: 'front',
    parent: 'cameraPreview',
    className: 'cameraPreview',
    toBack: false,
    width: window.innerWidth,
    height: window.innerHeight,
  };

  const base64ToFile = async (base64Data, filename) => {
    const res = await fetch(base64Data);
    const blob = await res.blob();
    return new File([blob], filename, { type: blob.type });
  };

  const handleCaptureFlow = async () => {
    if (!cameraActive) {
      try {
        // Start camera
        await CameraPreview.start(cameraOptions);
        setCameraActive(true);

        // Delay to ensure camera is initialized
        setTimeout(async () => {
          try {
            // Capture photo
            const result = await CameraPreview.capture({
              quality: 70,
              width: 640,
              height: 480,
              preserveAspectRatio: true,
            });
            const base64Image = `data:image/jpeg;base64,${result.value}`;
            setPhoto(base64Image);
            const file = await base64ToFile(base64Image, "photo.jpg");
            onPhotoCapture(file);
            // Stop camera and hide preview
            await CameraPreview.stop();
            setCameraActive(false);
          } catch (captureErr) {
            toast.error('Error capturing photo:', captureErr);
          }
        }, 2000);
      } catch (startErr) {
        toast.error('Error starting camera:', startErr);
      }
    }
  };

  const togglePreview = () => {
    setShowPreview(!showPreview);
  };

  const handleRecapture = () => {
    setPhoto(null);
    setShowPreview(false);
  }

  return (
    <div className="mx-2">
      {!photo && (
        <div
          id="cameraPreview"
        ></div>
      )}

      <div className="mx-2">
        {!photo && <div id="cameraPreview"></div>}

        <div className="mx-2">
          {!photo && (
            <button
              type="button"
              onClick={handleCaptureFlow}
              className="bg-secondary text-white px-4 py-2 rounded hover:bg-primary mx-2"
            >
              {cameraActive ? 'Capturing...' : 'Take Photo'}
            </button>
          )}

          {photo && (
            <>
              {/* Buttons Row */}
              <div className="flex items-center gap-4 mt-4">
                <button
                  type="button"
                  onClick={togglePreview}
                  className="text-xl bg-gray-200 p-2 rounded-full hover:bg-gray-300"
                  title={showPreview ? 'Hide Photo' : 'Show Photo'}
                >
                  <FaInfoCircle className='text-primary' />
                </button>

                <button
                  type="button"
                  onClick={handleRecapture}
                  className="text-primary underline flex items-center gap-1"
                >
                  <div className="flex items-center gap-1">
                    <FaTimesCircle />
                    <span>Clear Photo</span>
                  </div>
                </button>
              </div>

              {/* Preview Image Section */}
              {showPreview && (
                <div className="flex justify-center mt-6">
                  <img
                    src={photo}
                    alt="captured"
                    className="rounded shadow-md w-full max-w-xs rotate-[270deg]"
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>

    </div>
  );
};

export default CameraPreviewComponent;
